import { Amenity, Facility } from "@/lib/gql/__generated__/graphql";

export const AMENITIES_VALUES = Object.values(Amenity);

export const AMENITIES = [
	{
		key: "なし",
		value: Amenity["None"],
	},
	{
		key: "歯ブラシ",
		value: Amenity["ToothBrush"],
	},
	{
		key: "くし",
		value: Amenity["HairComb"],
	},
	{
		key: "ひげ剃り",
		value: Amenity["Razor"],
	},
	{
		key: "綿棒",
		value: Amenity["CottonSwabs"],
	},
	{
		key: "スリッパ",
		value: Amenity["Slipper"],
	},
	{
		key: "基礎化粧品",
		value: Amenity["BaseCosmetics"],
	},
	{
		key: "化粧水",
		value: Amenity["Toner"],
	},
	{
		key: "乳液",
		value: Amenity["Emulsion"],
	},
	{
		key: "シャワーキャップ",
		value: Amenity["ShowerCap"],
	},
	{
		key: "浴衣",
		value: Amenity["Yukata"],
	},
	{
		key: "パジャマ",
		value: Amenity["Pajama"],
	},
] as const;

export const BATH_ITEMS = [
	{
		key: "専用バスルーム",
		value: Amenity["PrivateBathroom"],
	},
	{
		key: "ユニットバス",
		value: Amenity["UnitBath"],
	},
	{
		key: "客室露天風呂",
		value: Amenity["PrivateOpenAirBath"],
	},
	{
		key: "大浴場",
		value: Amenity["LargePublicBath"],
	},
	{
		key: "客室サウナ",
		value: Amenity["PrivateSauna"],
	},
	{
		key: "シャワー",
		value: Amenity["Shower"],
	},
	{
		key: "バスタブ",
		value: Amenity["Bathtub"],
	},
	{
		key: "バスローブ",
		value: Amenity["BathRoab"],
	},
	{
		key: "ハンドタオル",
		value: Amenity["HandTowel"],
	},
	{
		key: "バスタオル",
		value: Amenity["BathTowel"],
	},
	{
		key: "シャンプー",
		value: Amenity["Shampoo"],
	},
	{
		key: "リンス",
		value: Amenity["Conditioner"],
	},
	{
		key: "ボディーソープ",
		value: Amenity["BodySoap"],
	},
	{
		key: "石鹸",
		value: Amenity["Soap"],
	},
	{
		key: "入浴剤",
		value: Amenity["BathAdditive"],
	},
	{
		key: "トイレ",
		value: Amenity["Toilet"],
	},
] as const;

export const FACILITIES_VALUES = Object.values(Facility);

export const FACILITIES = [
	{
		key: "WiFi",
		value: Amenity["Wifi"],
	},
	{
		key: "冷蔵庫",
		value: Amenity["Fridge"],
	},
	{
		key: "テレビ",
		value: Amenity["Tv"],
	},
	{
		key: "オーディオ機器",
		value: Amenity["AudioEquipment"],
	},
	{
		key: "プロジェクター",
		value: Amenity["Projector"],
	},
	{
		key: "Netflix",
		value: Amenity["Netflix"],
	},
	{
		key: "Hulu",
		value: Amenity["Hulu"],
	},
	{
		key: "エアコン",
		value: Amenity["AirConditioner"],
	},
	{
		key: "暖炉",
		value: Amenity["FirePlace"],
	},
	{
		key: "空気清浄機",
		value: Amenity["AirCleaner"],
	},
	{
		key: "加湿機",
		value: Amenity["Humidifier"],
	},
	{
		key: "アイロン",
		value: Amenity["Iron"],
	},
	{
		key: "ドライヤー",
		value: Amenity["Dryer"],
	},
	{
		key: "専用キッチン",
		value: Amenity["PrivateKitchen"],
	},
	{
		key: "調理用具",
		value: Amenity["CookingTool"],
	},

	{
		key: "電子レンジ",
		value: Amenity["MicrowaveOven"],
	},
	{
		key: "湯沸かしポット",
		value: Amenity["Pot"],
	},
	{
		key: "食器類",
		value: Amenity["Tableware"],
	},
	{
		key: "ウォシュレット",
		value: Amenity["Washlet"],
	},
	{
		key: "専用洗濯機",
		value: Amenity["PrivateWashingMachine"],
	},
	{
		key: "バルコニー",
		value: Amenity["Balcony"],
	},
	{
		key: "金庫",
		value: Amenity["Safe"],
	},
];

export const FACILITIES_FOOD = [
	{
		key: "施設内のカフェ",
		value: Facility["Cafe"],
	},
	{
		key: "施設内のバー",
		value: Facility["Bar"],
	},
	{
		key: "バーベキュー設備",
		value: Facility["BbqFacilities"],
	},
	{
		key: "自販機(スナック類)",
		value: Facility["VendingMachinesSnack"],
	},
	{
		key: "自販機(ドリンク類)",
		value: Facility["VendingMachinesDrink"],
	},
];

export const FACILITIES_SPA = [
	{
		key: "プール",
		value: Facility["Pool"],
	},
	{
		key: "温泉",
		value: Facility["HotSpring"],
	},
	{
		key: "露天風呂",
		value: Facility["OpenAirBath"],
	},
	{
		key: "サウナ",
		value: Facility["Sauna"],
	},
	{
		key: "マッサージ",
		value: Facility["Massage"],
	},
];

export const FACILITIES_TRANSPORT = [
	{
		key: "駐車場",
		value: Facility["ParkingLot"],
	},
	{
		key: "シャトル",
		value: Facility["Shuttle"],
	},
	{
		key: "レンタカー",
		value: Facility["CarRental"],
	},
];

export const FACILITIES_COMMON_AREA = [
	{
		key: "WiFi",
		value: Facility["PublicWifi"],
	},
	{
		key: "共用キッチン",
		value: Facility["PublicKitchen"],
	},
	{
		key: "共用ラウンジ",
		value: Facility["Lounge"],
	},
	{
		key: "図書館",
		value: Facility["Library"],
	},
	{
		key: "プレイルーム",
		value: Facility["PlayRoom"],
	},
	{
		key: "カラオケルーム",
		value: Facility["KaraokeRoom"],
	},
	{
		key: "共用バスルーム",
		value: Facility["PublicBathroom"],
	},
	{
		key: "共用シャワー",
		value: Facility["PublicShower"],
	},
	{
		key: "共用トイレ",
		value: Facility["PublicToilet"],
	},
	{
		key: "パウダールーム",
		value: Facility["PowderRoom"],
	},
	{
		key: "テレビ",
		value: Facility["PublicTv"],
	},
	{
		key: "Netflix",
		value: Facility["Netflix"],
	},
	{
		key: "Hulu",
		value: Facility["Hulu"],
	},
	{
		key: "暖炉",
		value: Facility["Fireplace"],
	},
	{
		key: "アイロン",
		value: Facility["PublicIron"],
	},
	{
		key: "ドライヤー",
		value: Facility["PublicHairdryer"],
	},
	{
		key: "電子レンジ",
		value: Facility["PublicMicrowave"],
	},
	{
		key: "湯沸かしポット",
		value: Facility["PublicElectricKettle"],
	},
	{
		key: "食器類",
		value: Facility["PublicTableware"],
	},
];

export const FACILITIES_CLEANING_SERVICE = [
	{
		key: "ランドリー",
		value: Facility["PublicLaundry"],
	},
	{
		key: "ドライクリーニング",
		value: Facility["DryCleaning"],
	},
	{
		key: "アイロンサービス",
		value: Facility["IroningService"],
	},
];
